import config from "../config";

export const getPublicFiles = (path) => {
    return `${config.url_api}/public/files/${path}`;
};

const getFiles = (path) => `${config.url_api}/arquivos/${path}`;

export default getFiles;
